"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ImageEdit_1 = require("../ImageEdit/ImageEdit");
/**
 * @deprecated Use ImageEdit plugin instead
 */
var ImageResize = /** @class */ (function (_super) {
    __extends(ImageResize, _super);
    /**
     * Create a new instance of ImageResize
     * @param minWidth Minimum width of image when resize in pixel, default value is 10
     * @param minHeight Minimum height of image when resize in pixel, default value is 10
     * @param selectionBorderColor Color of resize border and handles, default value is #DB626C
     * @param forcePreserveRatio Whether always preserve width/height ratio when resize, default value is false
     * @param resizableImageSelector Selector for picking which image is resizable (e.g. for all images not placeholders), note
     * that the tag must be IMG regardless what the selector is
     */
    function ImageResize(minWidth, minHeight, selectionBorderColor, forcePreserveRatio, resizableImageSelector) {
        if (minWidth === void 0) { minWidth = 10; }
        if (minHeight === void 0) { minHeight = 10; }
        if (selectionBorderColor === void 0) { selectionBorderColor = '#DB626C'; }
        if (forcePreserveRatio === void 0) { forcePreserveRatio = false; }
        if (resizableImageSelector === void 0) { resizableImageSelector = 'img'; }
        return _super.call(this, {
            minHeight: minHeight,
            minWidth: minWidth,
            borderColor: selectionBorderColor,
            preserveRatio: forcePreserveRatio,
            imageSelector: resizableImageSelector,
        }) || this;
    }
    /**
     * @deprecated
     */
    ImageResize.prototype.showResizeHandle = function (img) {
        this.setEditingImage(img, 3 /* Resize */);
    };
    /**
     * @deprecated
     */
    ImageResize.prototype.hideResizeHandle = function (selectImageAfterUnSelect) {
        this.setEditingImage(null /*image*/, selectImageAfterUnSelect);
    };
    return ImageResize;
}(ImageEdit_1.default));
exports.default = ImageResize;
//# sourceMappingURL=ImageResize.js.map